import {useTranslation} from '@aboutyou/i18n';
import {LinkProps} from '@aboutyou/router';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../constants/colors';
import {Button} from '../Buttons/Button';
import {Icon, IconSize} from '../Icon/Icon';
import {GenericIconName} from '../Icon/IconName';
import {BackButtonIconName} from './assets';

type IconType = 'arrowBack' | 'cross';

const BackIcon: FC<{iconType?: IconType; iconSize?: keyof typeof IconSize}> = ({
  iconType = 'arrowBack',
  iconSize,
}) => {
  return (
    <StyledIcon
      asset={
        iconType === 'arrowBack'
          ? BackButtonIconName.Back
          : GenericIconName.Close
      }
      data-testid="backButtonIcon"
      size={iconSize}
    />
  );
};

export const BackButton: FC<{
  className?: string;
  href?: LinkProps['to'];
  onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
  testId?: string;
  considerScrollTopAnchor?: boolean;
  iconType?: IconType;
  iconSize?: keyof typeof IconSize;
  showAsButton?: boolean;
}> = ({
  href,
  onClick,
  className,
  testId = 'backButton',
  considerScrollTopAnchor,
  iconType,
  iconSize,
  showAsButton = false,
}) => {
  const {t} = useTranslation();

  return (
    <StyledButton
      className={className}
      data-testid={testId}
      onClick={onClick}
      aria-label={t('Navigate back')}
      variant="secondary"
      round={true}
      href={href}
      considerScrollTopAnchor={considerScrollTopAnchor}
      size="sm"
      data-show-as-button={showAsButton}
    >
      <BackIcon iconType={iconType} iconSize={iconSize} />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  &&[data-show-as-button='false'] {
    box-shadow: none;
    --background-color: transparent;
    backdrop-filter: unset;
  }
`;

const StyledIcon = styled(Icon)`
  fill: inherit;
  width: 15px;
  height: 15px;
  fill: ${COLORS.Black};
`;
